import axios from 'axios';
import { FeatureFlags } from 'config/featureFlags';
import { useAuthedUser } from 'hooks/useIsAuthedUser';
import { FC, useEffect } from 'react';
import { useRegAndTicketingContext } from 'store/modules/eventTicketing';
import useSWR from 'swr';
import { useFeatureFlagContext } from 'utils/unleashFeatureFlags/FeatureFlagProvider';
import { FEATURE_FLAGS } from 'utils/unleashFeatureFlags/flags';
import Rtmp from '.';
import { useSessionTime } from '../hooks';
import { RegOrBuyTicket } from '../Modal/RegOrBuyTicketRequired';
import RTMPChina from '../RtmpChina';
import { SignInScreen } from '../Screens/SignInScreen';

const RTMPRender: FC<{ session: MorressierSession; authUserId: string | undefined }> = props => {
  const { session, authUserId } = props;
  const { features, unleash } = useFeatureFlagContext();
  const { data } = useSWR<{ ip: string; country_name: string; continent_name: string }>(
    'https://api.ipgeolocation.io/ipgeo?&fields=country_name,continent_name',
    url => axios.get(url).then(res => res.data),
  );
  useEffect(() => {
    if (unleash && data) {
      console.log('Location:', data.country_name);
      unleash.updateContext({
        properties: { country: data.country_name || '', region: data.continent_name || '' },
      });
    }
  }, [unleash, data]);

  const { isPostSession } = useSessionTime({
    startDate: session.start_date,
    endDate: session.end_date,
    options: { runPastDates: true },
  });

  const isTicketingFlagEnabled = FeatureFlags.Event_Ticketing.isEnabled();
  const { state } = useRegAndTicketingContext();
  const isAuthed = useAuthedUser();

  const regOrAccessRequired = () => {
    if (isTicketingFlagEnabled) {
      if (isAuthed && (state.userHasAccess || isPostSession)) return false;

      return true;
    }

    return false;
  };

  if (regOrAccessRequired()) {
    return <RegOrBuyTicket />;
  }

  if (!isAuthed) {
    return <SignInScreen />;
  }

  if (features[FEATURE_FLAGS.LIVE_RTMP_CHINA]) {
    return <RTMPChina session={session} userId={authUserId || 'Not logged in user'} />;
  }
  return <Rtmp session={session} userId={authUserId || 'Not logged in user'} />;
};

export default RTMPRender;
